/**
 * Escape a string for safe interpolation into an HTML fragment.
 *
 * Angular escapes interpolated values automatically, so this is only needed on the
 * paths that deliberately build an HTML string and hand it to `[innerHTML]` through
 * `bypassSecurityTrustHtml` (which switches the built-in sanitizer off). Names such
 * as an agent or report title are attacker-controlled free text, so concatenating
 * them into markup unescaped turned any list that renders them into stored XSS.
 *
 * Escapes the five characters that can change HTML structure or break out of an
 * attribute value.
 */
export function escapeHtml(value: unknown): string {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
